import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const originalError = console.error;

console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes("MUI: You have provided an out-of-range value")
  ) {
    return;
  }

  originalError(...args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
